import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { color } from 'framer-motion';
import { CopyBlock, dracula } from "react-code-blocks";


const JavaScriptLesson29 = () => {
  const [language, changeLanguage] = useState("javascript");
  const [lineNumbers, toggleLineNumbers] = useState(false);
  const code1 = (
  'text',
  `
  let age = 15;
  if (age < 18){
    console.log("Not eligible to drive.")
  }else {
    console.log("Eligible to drive")
  }
  `
  );
  const code2 = (
  'text',
  `
  switch(expression) {
    case condition 1: statements to be executed
    break;
    case condition 2: statements to be executed
    break;
    case condition n: statements to be executed break;
    default: statements to be executed
  }
  `
  );
  const code3 = (
  'text',
  `
  let grade = "A";
  switch (grade) case 'A': console.log("Excellent");
  break;
  case 'B': console.log("Good");
  break;
  case 'C': console.log("Credit");
  break;
  case 'D': console.log("Pass");
  break;
  case 'F': console.log("Fail");
  break;
  default: "No grade found";
  `
  );
  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">
  <h3><strong>Control Structures</strong></h3>
  <p>Control structures allow the program flow to change within a unit of code or function, and they determine whether or not the given statements are executed.</p>

  <div class="alert alert-secondary" role="alert">
  <h4><strong>IF - ELSE Statements</strong></h4>
  <p>While writing your JavaScript program, there may be times when you need to adopt one out of a given set of paths. In such case, you need to use conditional statements.</p>
  <p>The <strong>IF - ELSE</strong> statement is a conditional statment that allows your program to make a correct decision out of several conditions.</p>
  <h3>Example</h3>
  <CopyBlock
  language={language}
  text={code1}
  showLineNumbers={lineNumbers}
  theme={dracula}
  wrapLines={true}
  codeBlock
  />
  </div>
  <div class="alert alert-secondary" role="alert">
  <h4><strong>Switch Case</strong></h4>
  <p>A <strong>switch</strong> statment gives an expression a value to evaluate and several different statements to execute based on the value of the expression.</p>
  <CopyBlock
  language={language}
  text={code2}
  showLineNumbers={lineNumbers}
  theme={dracula}
  wrapLines={true}
  codeBlock
  />
  <p>The <strong>break</strong> statement indicates the end of a particular case</p>
  <CopyBlock
  language={language}
  text={code3}
  showLineNumbers={lineNumbers}
  theme={dracula}
  wrapLines={true}
  codeBlock
  />
  </div>
  </div>
  </div>
  </div>
  </HTMLCourseNavProvider>
  )
}

export default JavaScriptLesson29
